import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Subscriptions from "./pages/Subscriptions";
import Transactions from "./pages/Transactions";
import Invoices from "./pages/Invoices";
import Checkout from "./pages/Checkout";
import Settings from "./pages/Settings";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminConfig from "./pages/admin/AdminConfig";
import SimplifiedPaymentConfig from "./pages/admin/SimplifiedPaymentConfig";
import AdminUsers from "./pages/admin/AdminUsers";
import "./App.css";

function PrivateRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  console.log(
    "[PrivateRoute] Loading:",
    loading,
    "User:",
    user,
    "AdminOnly:",
    adminOnly
  );

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!user) {
    console.log("[PrivateRoute] No user - redirecting to login");
    return <Navigate to="/login" />;
  }

  if (adminOnly) {
    const hasAdminRole =
      user.roles?.includes("admin") ||
      user.roles?.includes("super_admin") ||
      user.roles?.includes("payments.admin");

    const hasAdminPermission =
      user.permissions?.includes("payments.dashboard.admin") ||
      user.permissions?.includes("payments.admin");

    console.log(
      "[PrivateRoute] Admin check - User roles:",
      user.roles,
      "Has admin:",
      hasAdminRole || hasAdminPermission
    );

    if (!hasAdminRole && !hasAdminPermission) {
      console.log(
        "[PrivateRoute] User lacks admin role/permission - redirecting to dashboard"
      );
      return <Navigate to="/dashboard" />;
    }
  }

  return children;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/checkout/:priceId" element={<Checkout />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="settings" element={<Settings />} />

        {/* Admin Routes */}
        <Route
          path="admin"
          element={
            <PrivateRoute adminOnly>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="admin/integrations"
          element={
            <PrivateRoute adminOnly>
              <AdminConfig />
            </PrivateRoute>
          }
        />
        <Route
          path="admin/pricing"
          element={
            <PrivateRoute adminOnly>
              <SimplifiedPaymentConfig />
            </PrivateRoute>
          }
        />
        <Route
          path="admin/users"
          element={
            <PrivateRoute adminOnly>
              <AdminUsers />
            </PrivateRoute>
          }
        />
      </Route>
    </Routes>
  );
}

export default App;
